import React from "react";
import SupportFooter from "@/components/SupportFooter";

type AppShellFrameProps = {
  sidebar: React.ReactNode;
  topBar?: React.ReactNode;
  children: React.ReactNode;
};

export default function AppShellFrame({
  sidebar,
  topBar,
  children,
}: AppShellFrameProps) {
  return (
    <div className="h-screen overflow-hidden bg-slate-50 text-slate-900 antialiased dark:bg-slate-950 dark:text-slate-100">
      <div className="flex h-screen w-full flex-col lg:flex-row">
        <aside className="w-full shrink-0 border-b border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950 lg:h-screen lg:w-80 lg:border-b-0 lg:border-r">
          <div className="h-full min-w-0 overflow-x-hidden overflow-y-auto">{sidebar}</div>
        </aside>

        <div className="min-w-0 flex-1 overflow-hidden">
          {topBar ? (
            <div className="sticky top-0 z-40 w-full border-b border-slate-200 bg-white/95 backdrop-blur dark:border-slate-800 dark:bg-slate-950/95">
              {topBar}
            </div>
          ) : null}

          <main className={`${topBar ? "h-[calc(100vh-61px)]" : "h-screen"} overflow-y-auto overflow-x-hidden px-4 py-6 sm:px-6 lg:px-8`}>
            <div className="mx-auto min-w-0 max-w-6xl">
              {children}
              <div className="mt-8 border-t border-slate-200 pt-4 dark:border-slate-800">
                <SupportFooter />
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}